<template>
    <div>
        <div class="flex flex-row items-center justify-between border-b border-blue-900 px-3 py-2">
            <h2 class="font-bold">Current Benchmarking for {{ building.custom_building_id }}</h2>
            <p>
                Current Status:
                <span v-if="reportDate">(submitted on {{ reportDate | date_format(true) }})</span>
                <span v-else>Data Not Reported</span>
            </p>
            <action-button
                color="blue"
                :disabled="flags.length <= 0"
                @click="handleShowFlags()"
            >
                {{ flags.length }} Flag(s)
            </action-button>
        </div>
        <div class="mt-3 px-3">
            <base-table
                class="report-table"
                :data="benchmarkingList"
                :columns="columns"
                :loading="loading"
            >
                <template v-slot="{ row, index }">
                    <td :class="`${ tableRowBaseClass(index) }`">{{ row.benchmarking_status }}</td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ row.normalized_net_site_eui | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ row.reported_gfa | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ parseInt(row.reported_electricity) | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ row.reported_natural_gas | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ row.direct_ghg_emissions_intensity | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                    <td :class="`${ tableRowBaseClass(index) } text-right`">
                        <span v-if="!row.is_undisclosed">{{ row.direct_ghg_emissions | number_format }}</span>
                        <span v-else>Undisclosed</span>
                    </td>
                </template>
            </base-table>
        </div>
    </div>
</template>
<script>
import FlagsList from './FlagsListPartial.vue';

export default {
    props: {
        building: {
            type: Object,
            default: () => {}
        },
        flags: {
            type: Array,
            default: () => []
        },
        submissions: {
            type: Array,
            default: () => []
        },
        beps: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            columns: [
                { label: 'Benchmarking Status', field: 'benchmarking_status', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Normalized Net Site EUI', field: 'normalized_net_site_eui', customHeaderClass: 'w-32 align-top border border-b-4 border-white' },
                { label: 'Reported GFA', field: 'reported_gfa', customHeaderClass: 'w-36 align-top border border-b-4 border-white' },
                { label: 'Reported Electricity (kWh)', field: 'reported_electricity', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Reported Natural Gas (kBtu)', field: 'reported_natural_gas', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Direct GHG Emissions Intensity (kgCO2e/ft²)', field: 'direct_ghg_emissions_intensity', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Direct GHG Emissions (Metric Tons CO2e)', field: 'direct_ghg_emissions' }
            ],
            loading: false,
        };
    },
    computed: {
        currentSubmission() {
            let submission = null;
            if (this.submissions && this.submissions.length > 0) {
                submission = this.submissions.find(s => parseInt(s.reporting_year) === new Date().getFullYear());
            }
            return submission;
        },
        benchmarkingList() {
            const list = [];
            const item = this.currentSubmission;
            if (item) {
                list.push({
                    benchmarking_status: item.status,
                    normalized_net_site_eui: item.normalized_net_site_eui,
                    reported_gfa: item.reported_gfa,
                    reported_electricity: parseInt(item.electricity_use_grid_purchase_and_onsite_kwh),
                    reported_natural_gas: item.natural_gas_use_kbtu,
                    direct_ghg_emissions_intensity: item.direct_ghg_emissions_intensity,
                    direct_ghg_emissions: item.direct_ghg_emissions,
                    is_undisclosed: item.is_undisclosed,
                });
            }

            return list;
        },

        reportDate() {
            let result = null;
            if (this.currentSubmission) {
                result = this.currentSubmission.reporting_date;
            }
            return result;
        }

    },

    methods: {
        tableRowBaseClass(index) {
            return index % 2 ? 'bg-blue-50' : 'bg-blue-100';
        },
        handleShowFlags() {
            this.$touchstone.modal({
                component: FlagsList,
                maxWidth: 'md',
                props: {
                    flags: this.flags
                }
            });
        },
        floatValue(value) {
            return value && !isNaN(value) ? parseFloat(value) : 0;
        }
    }
};

</script>
